"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
class OfferRequest extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.SegmentType)),
    (0, base_models_1.Docs)({ example: base_models_1.SegmentType.SOHO, description: 'The type of segment the address falls in.' }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], OfferRequest.prototype, "segmentType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '1234AB_56_C',
        description: `Address of the building for which the offer is intended.
It should match the same address you have used to get the profile id from the Identification Service`,
    }),
    (0, base_models_1.IsAddressKey)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], OfferRequest.prototype, "deliveryAddress", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    (0, base_models_1.Docs)({
        example: false,
        description: `Also known as complex bepaling.
      This information is maintained by EDSN.
      For tariffs, if residential is true and complex is false, that address will get belasting voordeel.
      If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
      Defaults to false.`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Boolean)
], OfferRequest.prototype, "complex", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Boolean),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        example: false,
        description: `If true it means that is a "regular" home.
    It only influence if it receives belasting voordeel.
    If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
    If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
    Defaults to true`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Boolean)
], OfferRequest.prototype, "residential", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 2000,
        description: 'The expected yearly electricity consumption in kWh',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Number)
], OfferRequest.prototype, "electricityConsumptionPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 900,
        description: 'The expected yearly electricity consumption in kWh in the "off" hours',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Number)
], OfferRequest.prototype, "electricityConsumptionOffPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 200,
        description: 'The expected amount of kWh that is returned on the net during the day',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Number)
], OfferRequest.prototype, "electricityConsumptionReturnPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, base_models_1.Docs)({
        example: 5,
        description: 'The expected amount of kWh that is returned on the net in the "off" hours',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Number)
], OfferRequest.prototype, "electricityConsumptionReturnOffPeak", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(offerstore_api_models_1.ElectricityInstallationProfile)),
    (0, base_models_1.Docs)({
        example: offerstore_api_models_1.ElectricityInstallationProfile.E1A,
        description: `The profile of the electricity meter/installation.
heavily influences the supply rates. Describes the maximum usage of the building.
We try to find the profile if it is an existing customer, otherwise it will default to E1C.`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], OfferRequest.prototype, "electricityInstallationProfile", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '8742010202112',
        description: `States what kind of installation you have.
For example if you have 3x25 ampere or only 1x80.
This heavily influences the tariffs you receive.
You find the result under "Netbeheerder kosten".`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], OfferRequest.prototype, "electricityCaptarEAN", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({
        maxDecimalPlaces: 0,
    }),
    (0, class_validator_1.Min)(0),
    (0, base_models_1.Docs)({
        example: 600,
        description: `The expected yearly gas consumption in m3.
If not set, it will try to fetch the consumption of EDSN if it is an existing customer.
Otherwise it will default to 1_300`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Number)
], OfferRequest.prototype, "gasConsumption", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '871718518003014972',
        description: `The net area EAN, can be retrieved from EDSN also for non existing customers.
This determines in which "region" you live, numbered from 01 up to 10.
For each region there is a different supply rate.
For example with the same installation and segment, but different net area, could result in a difference of 0.01 euro in unit price.`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], OfferRequest.prototype, "gasNetAreaEAN", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(offerstore_api_models_1.GasInstallationProfile)),
    (0, base_models_1.Docs)({
        example: offerstore_api_models_1.GasInstallationProfile.G1A,
        description: `The profile of the gas meter/installation.
Describes the maximum usage of the building.
Heavily influences the supply rates.
We try to find the profile if it is an existing customer, otherwise it will default to G1A.`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], OfferRequest.prototype, "gasInstallationProfile", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '8742010202112',
        description: `States per netbeheerder the maximum amount of gas in m3 per hour the building is allowed to use.
For example, if the gas installation has the captar 8742080201114 is then managed by NV Rendo and states the maximum input is 10m3/h with a maximum year usage of less than 500m3 gas.
This value can be retrieved at EDSN for everyone.
This heavily influences the tariffs you receive.
You find the result under "Netbeheerder kosten".`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], OfferRequest.prototype, "gasCaptarEAN", void 0);
exports.default = OfferRequest;
